module.exports = __webpack_public_path__ + "img/bureau-luthi-logo-main-small-black.43457859.png";